import { createEffect } from 'effector'
import { MyAPI } from '../../services/api/My'

export const getMyFx = createEffect(MyAPI.getMy)
